export default "__VITE_ASSET__CaAn_0IS__"